export const EDIT_PROFILE = "EDIT_PROFILE"
export const UPDATE_PROFILE = "UPDATE_PROFILE"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
